import React, { Dispatch, RefObject } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { responsiveFontSize } from "@common/components/Typography/style";
import { LineChartInstance } from "../../types";

type ResetButtonProps = {
  chartRef: RefObject<LineChartInstance | null>;
  setZoomLevel: Dispatch<React.SetStateAction<number>>;
};

const ResetButton = ({ chartRef, setZoomLevel }: ResetButtonProps) => {
  const { t } = useTranslation();
  const label = t("Reset");

  const handleClick = () => {
    chartRef.current?.resetZoom();
    setZoomLevel(1);
  };

  return (
    <Button
      onClick={handleClick}
      sx={(theme) => responsiveFontSize(theme, "medium")}
    >
      {label}
    </Button>
  );
};

export default ResetButton;
